import { TextInput } from '@ksyos/design-system';
import { getValidationErrorTranslation } from '@frontend/utils';
import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import type { INullableTextInputProps } from './NullableText';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';
import { TextAreaInput } from './TextArea';

export function NewNullableTextInput(props: FormContextProps<INullableTextInputProps>) {
    return (
        <FormContextConsumer {...props}>
            {(properties) => {
                const nonNullableProps = {
                    ...properties,
                    value: properties.value === null ? '' : properties.value,
                    onChange: (value: string | null) => properties.onChange(value === '' ? null : value),
                };

                if (properties.expandableTextArea) {
                    return (
                        <TextAreaInput
                            {...nonNullableProps}
                            style={properties.inputStyle}
                        />
                    );
                }
                const classNames = properties.automation
                    ? `automation-${properties.automation} ${properties.className}`
                    : properties.className;

                return (
                    <TextInput
                        className={classNames}
                        data-automation-test={properties.automation}
                        disabled={properties.disabled}
                        error={getValidationErrorTranslation(properties.error)}
                        onChange={(e) => {
                            properties.onChange(e.target.value === '' ? null : e.target.value);
                        }}
                        onEnterKeyPress={properties.onEnter}
                        placeholder={properties.placeholder}
                        value={properties.value ?? ''}
                    />
                );
            }}
        </FormContextConsumer>
    );
}

export function NewNullableTextField(props: FormContextProps<INullableTextInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <NewNullableTextInput {...props} />
        </Field>
    );
}
